<template>
      <div></div>
</template>

<script>

    export default {

        data: function() {
            return  {
                formcompleted: false,
                formdata:{
                    'start' :
                    {
                        title: this.trans.application.titel_start_datum[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                       fields:[
                           {
                               id: 'startdate',
                               name: 'Start Datum',
                               value: '',
                               label: '',
                               type: 'datemonth',
                               mode: 'next',
                               validation: ['required'],
                               placeholder: false,
                           }
                       ]
                    },
                    'your' :
                    {
                        title: this.trans.application.titel_ihre_angaben[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'your-name',
                                name: 'Name',
                                value: '',
                                label: this.trans.application.name[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'your-firstname',
                                name: 'Vorname',
                                value: '',
                                label: this.trans.application.vorname[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                        ]
                    },
                    'child' :
                    {
                        title: this.trans.application.titel_angaben_kind[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'child-name',
                                name: 'Name',
                                value: '',
                                label: this.trans.application.name[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'child-firstname',
                                name: 'Vorname(n)',
                                value: '',
                                label: this.trans.application.vornamen[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                             {
                                id: 'lunch-diet',
                                titlebefore:  this.trans.application.hotlunch[this.lang],
                                name: 'Spezielle Diät',
                                value: '',
                                label: '<span style="display:block;padding-bottom:0.3em">'+this.trans.application.fragen_diaet[this.lang]+'</span>',
                                type: 'checkbox',
                                selection:[this.trans.application.fragen_vegan[this.lang],this.trans.application.fragen_vegi[this.lang],this.trans.application.fragen_schwein[this.lang],this.trans.application.fragen_gluten[this.lang],this.trans.application.fragen_laktose[this.lang]],
                                validation: [],
                            },
                            {
                                id: 'lunch-allergies',
                                name: 'Bekannte Nahrungsmittelallergien',
                                value: '',
                                label: this.trans.application.fragen_bekannte_allergien[this.lang],
                                type: 'textarea',
                                validation: [],
                            },
                            {
                                id: 'lunch-other',
                                name: 'Andere Diätwünsche',
                                value: '',
                                label: this.trans.application.fragen_andere_diaet[this.lang],
                                type: 'textarea',
                                validation: [],
                            },

                        ]
                    },
                    'general-policy': {
                        title: "",
                        status: 0,
                        open: false,
                        haserror: false,
                        type: 'fix',
                        fields:[
                            {
                                id: 'general-policy',
                                name: 'Mit dieser Anmeldung bin ich mit den Datenschutzrichtlinien von der Lakeside School einverstanden.',
                                value: '',
                                label: this.trans.application.agree[this.lang],
                                type: 'checkbox',
                                selection:[ this.trans.application.ja[this.lang]],
                                validation: ['required']
                            },

                         ]
                    },
                    'general-conditions':
                    {
                        title: "",
                        status: 0,
                        open: false,
                        haserror: false,
                        type: 'fix',
                        fields:[
                            {
                                id: 'general-conditions',
                                name: 'Ich habe die Zahlungsbedingungen und Kündigungsfristen gelesen und bin einverstanden.',
                                value: '',
                                label: this.trans.application.agreeterms[this.lang],
                                type: 'checkbox',
                                selection:[ this.trans.application.ja[this.lang]],
                                validation: ['required']
                            },

                         ]
                    }



                }
            }
        },
        props: {

             lang: {
                type: String,
                required: true
            },
            trans: {
                type: Object,
                required: true
            },

        },


    }
</script>
